export default class UsuarioLogado {
  constructor(
    sshd = "",
    nome = "",
    perfis = [],
    primeiroNome = "",
    idPessoa = 0,
    cpf = '',
    funcionarios = []
  ) {
    this.sshd = sshd;
    this.nome = nome;
    this.perfis = perfis;
    this.primeiroNome = primeiroNome;
    this.idPessoa = idPessoa;
    this.cpf = cpf;
    this.funcionarios = funcionarios;
  }
}



// WEBPACK FOOTER //
// ./src/domain/usuarioLogado/index.js